/* eslint-disable no-use-before-define */
import React, { useState, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { FaExpand, FaCompress, FaSave, FaTimes } from 'react-icons/fa';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './RichTextEditor.css';
import PropTypes from 'prop-types';

RichTextEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  isEditing: PropTypes.bool,
  placeholder: PropTypes.string,
  maxImages: PropTypes.number,
  disabled: PropTypes.bool,
};

RichTextEditor.defaultProps = {
  onSave: null,
  onCancel: null,
  isEditing: null,
  placeholder: 'Digite aqui...',
  maxImages: 10,
  disabled: false,
};

function RichTextEditor({
  value,
  onChange,
  onSave,
  onCancel,
  isEditing,
  placeholder,
  maxImages,
  disabled,
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  const quillRef = useRef(null);
  // Configuração dos módulos do ReactQuill com suporte a imagens
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ color: [] }, { background: [] }],
      ['link', 'image'],
      ['clean'],
    ],
    clipboard: {
      // Permite colar imagens
      matchVisual: false,
    },
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'color',
    'background',
    'link',
    'image',
  ];

  const handleSave = () => {
    if (onSave) {
      onSave();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
  };

  // Modo de visualização (quando isEditing é false)
  if (isEditing === false) {
    return (
      <div
        className="rich-text-display"
        dangerouslySetInnerHTML={{ __html: value }}
      />
    );
  }

  // Modo de formulário simples (quando isEditing é null/undefined)
  // ou modo de edição inline (quando isEditing é true)
  const isInlineEditMode = isEditing === true;
  const isSimpleFormMode = isEditing === null || isEditing === undefined;

  return (
    <div className={`rich-text-editor ${isExpanded ? 'expanded' : ''}`}>
      {isInlineEditMode && (
        <div className="rich-text-header">
          <div className="rich-text-controls">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setIsExpanded(!isExpanded)}
              title={isExpanded ? 'Minimizar' : 'Expandir'}
            >
              {isExpanded ? <FaCompress /> : <FaExpand />}
            </Button>
          </div>

          <div className="rich-text-actions">
            <Button variant="secondary" size="sm" onClick={handleCancel}>
              <FaTimes /> Cancelar
            </Button>
            <Button
              variant="primary"
              size="sm"
              onClick={handleSave}
              className="ms-2"
            >
              <FaSave /> Salvar
            </Button>
          </div>
        </div>
      )}

      <div className="quill-container">
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={value}
          onChange={onChange}
          modules={modules}
          formats={formats}
          readOnly={disabled}
          style={{
            height: isExpanded ? '400px' : '200px',
            marginBottom: isInlineEditMode ? '50px' : '0px',
          }}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
}

export default RichTextEditor;
